/**
 * Copy text, reporting success instead of throwing. jsdom (and any non-secure
 * context) has no clipboard — treat that as a failed copy rather than crashing
 * the flow; callers show their own "copied" affordance only on true.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
